module.exports = __webpack_public_path__ + "img/hotdog_jumbo_especial.ebadab4e.jpeg";